import * as XLSX from "xlsx";

type ExcelColumn = {
  header: string;
  key: string;
  width?: number;
};

type ExcelData = Record<string, string | number | boolean | null | undefined>;

/**
 * 데이터를 엑셀 파일로 다운로드합니다.
 * @param data - 다운로드할 데이터 배열
 * @param columns - 컬럼 정의 (header: 표시될 헤더명, key: 데이터의 키)
 * @param fileName - 파일명 (확장자 제외)
 * @param sheetName - 시트명 (기본값: "Sheet1")
 */
export const downloadExcel = <T extends ExcelData>(
  data: T[],
  columns: ExcelColumn[],
  fileName: string,
  sheetName: string = "Sheet1"
) => {
  // 헤더와 데이터를 분리하여 배열 생성
  const headers = columns.map((col) => col.header);
  const rows = data.map((item) =>
    columns.map((col) => {
      const value = item[col.key];
      return value ?? "";
    })
  );

  // 워크시트 생성
  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

  // 컬럼 너비 설정
  const colWidths = columns.map((col) => ({ wch: col.width || 15 }));
  worksheet["!cols"] = colWidths;

  // 워크북 생성
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // 파일 다운로드
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

/**
 * 현재 날짜와 시간을 파일명에 사용할 수 있는 형식으로 반환합니다.
 */
export const getExcelFileName = (prefix: string) => {
  const now = new Date();
  const dateStr = now
    .toLocaleDateString("ko-KR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .replace(/\. /g, "")
    .replace(/\./g, "");
  const timeStr = now
    .toLocaleTimeString("ko-KR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    })
    .replace(/:/g, "");

  return `${prefix}_${dateStr}_${timeStr}`;
};
